"use client";

import { useEffect } from "react";
import { useTranslations } from "next-intl";
import { isStaleChunkError } from "@/lib/utils";

/** Root error boundary — no route previously had one, so any render error crashed to Next's default screen with no recovery. */
export default function RootError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const t = useTranslations("errorBoundary");

  useEffect(() => {
    if (isStaleChunkError(error.message)) window.location.reload();
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
      <p className="text-lg font-medium text-foreground-900">{t("title")}</p>
      <p className="text-sm text-muted">{t("description")}</p>
      <button
        type="button"
        onClick={reset}
        className="rounded-lg bg-secondary-950 px-5 py-2 text-sm font-medium text-white hover:bg-secondary-900"
      >
        {t("retry")}
      </button>
    </div>
  );
}
